export default __webpack_public_path__ + "static/media/open-book.912916c2.png";